import { Flow } from 'signup-constants/Flow';
import { getFlowKey } from '../routing/getFlowKey';
import { getIsMobile } from './deviceUtils';
import { SignupEmbedder } from 'signup-embedder';

// Currently, only these two flows are postponded to show the side panel,
// Becauase the side panel layout is not align with HSFX program which is after the signup flow.
export const NON_SOFTWARE_SIGNUP_FLOWS_THAT_SHOW_SIDE_PANEL = [Flow.HubSpotPartners, Flow.HubspotForStartups];
export const getShouldShowSidePanel = () => {
  const flowKey = getFlowKey();
  const isEnabledByFlow = !NON_SOFTWARE_SIGNUP_FLOWS_THAT_SHOW_SIDE_PANEL.includes(flowKey);
  const isMobile = getIsMobile();
  const isEmbedded = SignupEmbedder.isActive();
  if (isMobile || isEmbedded) {
    return false;
  }
  return isEnabledByFlow;
};